import { render, staticRenderFns } from "./KoioteProperties1.vue?vue&type=template&id=7ff2fcca&lang=true"
import script from "./KoioteProperties1.vue?vue&type=script&lang=js"
export * from "./KoioteProperties1.vue?vue&type=script&lang=js"
import style0 from "./KoioteProperties1.vue?vue&type=style&index=0&id=7ff2fcca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports